export default __webpack_public_path__ + "static/media/investment-vectores.923e0c2f.png";